import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { LoadingPage } from '@core/ui';
import { getOryPublicUrl } from '../core/ory/ory-config';
/**
 * SetupPage - Handles invite link recovery flow
 *
 * Extracts flow & code from URL, submits to Kratos, and redirects on success.
 */
export function SetupPage() {
    const hasSubmittedRef = useRef(false);
    const redirectToLogin = (email, errorMsg) => {
        const loginUrl = new URL('/auth/login', window.location.origin);
        if (email) {
            loginUrl.searchParams.set('email', email);
        }
        if (errorMsg) {
            loginUrl.searchParams.set('error', errorMsg);
        }
        window.location.href = loginUrl.toString();
    };
    useEffect(() => {
        if (hasSubmittedRef.current)
            return;
        hasSubmittedRef.current = true;
        const params = new URLSearchParams(window.location.search);
        const flowId = params.get('flow');
        const code = params.get('code');
        const email = params.get('email');
        if (!flowId || !code) {
            redirectToLogin(email, 'Invalid invitation link. Missing flow or code parameters.');
            return;
        }
        const submitRecovery = async () => {
            const kratosUrl = getOryPublicUrl();
            try {
                const response = await fetch(`${kratosUrl}/self-service/recovery?flow=${flowId}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    credentials: 'include',
                    body: JSON.stringify({ code, method: 'code' })
                });
                const data = await response.json();
                // 422 with browser_location_change_required = SUCCESS
                if (response.status === 422 && data.redirect_browser_to) {
                    window.location.href = data.redirect_browser_to;
                    return;
                }
                // 400 = Invalid or expired code
                if (response.status === 400) {
                    const errorMsg = data.ui?.messages?.[0]?.text || 'Invalid or expired code.';
                    redirectToLogin(email, errorMsg);
                    return;
                }
                // 410 = Flow expired
                if (response.status === 410) {
                    redirectToLogin(email, 'Invitation link has expired. Please request a new invite.');
                    return;
                }
                // Any other error
                redirectToLogin(email, 'Something went wrong. Please try again or contact support.');
            }
            catch (err) {
                redirectToLogin(email, `Connection error: ${err.message}`);
            }
        };
        submitRecovery();
    }, []);
    return _jsx(LoadingPage, {});
}
